<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <AppAddUpdateModal :id="id" :title="(languageToEdit ? $t($getConst.pages.language.update_new_language):$t($getConst.pages.language.add_new_language)) | capitalize">
    <template v-slot:form>
      <LanguageForm :modal_id="id" :languageToEdit="languageToEdit"/>
    </template>
  </AppAddUpdateModal>
</template>

<script>
  import LanguageForm from "./LanguageForm";
  import AppAddUpdateModal from "../../components/common/modals/AppAddUpdateModal";
  export default {
    name: "LanguageModal",
    components: {LanguageForm, AppAddUpdateModal},
    props: {
      id: null,
      languageToEdit: null,
    }
  }
</script>

<style scoped>

</style>
